import React, { useContext, useState, useEffect } from "react";
import { message } from "antd";
import { techCardsAPI } from "src/shared/api/techCardsAPI";
import { TechCards } from "src/enitities/Table";
import { TechCardContext } from "src/shared/lib/hooks/context/getTechCardsContext";
import { addRow, removeRow, saveRow } from "src/shared";

export default function TableTechCards() {
  const { token, websocket, data, refreshData } = useContext(TechCardContext);
  const [dataSource, setDataSource] = useState([]);
  const [loading] = useState(false);

  useEffect(() => {
    console.log("Data from context:", data);
    if (data) {
      const formattedData = data.map(techCard => ({
        ...techCard,
        items_count: techCard.items ? techCard.items.length : 0,
        created_at: techCard.created_at || techCard.dated || new Date().toISOString()
      }));
      setDataSource(formattedData);
      console.log("Formatted dataSource:", formattedData);
    }
  }, [data]);

  useEffect(() => {
    console.log("Setting up WebSocket listener");
    if (websocket) {
      websocket.onmessage = (message) => {
        console.log("WebSocket message received:", message.data);
        const data = JSON.parse(message.data);
        if (data.target === "tech_cards") {
          if (data.action === "create") {
            const newTechCard = {
              ...data.result,
              items_count: data.result.items ? data.result.items.length : 0,
              created_at: data.result.created_at || new Date().toISOString()
            };
            addRow(dataSource, newTechCard, setDataSource);
          }
          if (data.action === "edit") {
            const updatedTechCard = {
              ...data.result,
              items_count: data.result.items ? data.result.items.length : 0
            };
            saveRow(dataSource, updatedTechCard, setDataSource);
          }
          if (data.action === "delete") {
            removeRow(dataSource, data.result.id, setDataSource);
          }
        }
      };

      return () => {
        console.log("Cleaning up WebSocket listener");
        websocket.onmessage = null;
      };
    }
  }, [token, dataSource, websocket]);

  const handleSave = async (record) => {
    try {
      console.log("Saving record:", record);
      const saveData = {
        ...record,
        items_count: undefined,
        created_at: undefined
      };
     await techCardsAPI.create(token)(saveData, record.id);
     await techCardsAPI.update(token)(saveData, record.id);
      if (refreshData) {
        await refreshData();
      }
    } catch (error) {
      console.error('Error saving tech card:', error);
      console.log('Error response:', error.response?.data);
      message.error('Ошибка при сохранении техкарты');
    }
  };

  const handleRemove = async (id) => {
    try {
      console.log("Removing tech card with id:", id);
      await techCardsAPI.remove(token)(id);
      if (refreshData) {
        await refreshData();
      }
    } catch (error) {
      console.error('Error removing tech card:', error);
    }
  };

  return (
    <TechCards
      dataSource={dataSource}
      handleSave={handleSave}
      handleRemove={handleRemove}
      token={token}
      loading={loading}
    />
  );
}